import {FC} from "react"
import {Component} from "../../types/ContentStructure"
import {Box, SxProps, Typography} from "@mui/material"
import ComponentImage from "./ComponentImage"
import CssFilterConverter from "css-filter-converter"

interface ComponentBannerTextProps {
    component: Component
    sx?: any
}

const ComponentBannerText: FC<ComponentBannerTextProps> = ({component, sx = {}}) => {
    const {theme, title, subTitle, text, image} = component;

    const color_filter = CssFilterConverter.hexToFilter(theme.themeStyles.backgroundColor || '#FFF');

    return (
        <Box sx={[
            {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                py: {xs: 3, md: 5},
                px: {xs: 3, md: 8},
                width: '100%',
                // Fondo siempre gris claro — independiente del theme del CMS
                backgroundColor: '#F5F5F5',
                color: '#545454',
                mb: 6
            },
            {...sx}
        ]}>
            {/* Logo / imagen opcional */}
            {image && (
                <ComponentImage
                    component={component}
                    sx={{
                        height: 'auto',
                        width: 'auto',
                        maxHeight: 60,
                        objectFit: 'contain',
                        backgroundColor: 'transparent',
                        mb: 2,
                        //filter: `${color_filter.color!}`,
                    }}
                />
            )}

            {title && (
                <Typography variant="h2" sx={{
                    fontWeight: 100,
                    maxWidth: '60ch',
                    mb: 0.5,
                }}>
                    {title}
                </Typography>
            )}

            {subTitle && (
                <Typography variant="h2" sx={{
                    fontWeight: 600,
                    maxWidth: '60ch',
                }}>
                    {subTitle}
                </Typography>
            )}

            {text && (
                <Typography variant="body1" sx={{
                    mt: 1,
                    maxWidth: '60ch',
                }}>
                    {text.split('. ').map((paragraph, index) => (
                        <span key={index}>
                            {paragraph.trim()}
                            {index < text.split('. ').length - 1 && (<>.<br/></>)}
                        </span>
                    ))}
                </Typography>
            )}
        </Box>
    )
}

export default ComponentBannerText
